var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _text, _text2, _text3, _text4, _text5, _g, _text6, _g2, _text7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrackets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1920px",
    height: "1080px",
    viewBox: "0 0 1920 1080",
    enableBackground: "new 0 0 1920 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    x1: 479.5,
    y1: 40,
    x2: 479.5,
    y2: 1040
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    x1: 476,
    y1: 40.5,
    x2: 528,
    y2: 40.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    x1: 476,
    y1: 1040.5,
    x2: 527,
    y2: 1040.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    x1: 1438.5,
    y1: 43,
    x2: 1438.5,
    y2: 1043
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    x1: 1390,
    y1: 39.5,
    x2: 1442,
    y2: 39.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    x1: 1389,
    y1: 1040.5,
    x2: 1440,
    y2: 1040.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 1279,
    y1: 109,
    x2: 1279,
    y2: 989
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 1264,
    y1: 109,
    x2: 1281,
    y2: 109
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 1262,
    y1: 988,
    x2: 1279,
    y2: 988
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 638,
    y1: 109,
    x2: 638,
    y2: 989
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 637,
    y1: 109,
    x2: 654,
    y2: 109
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#0985CF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 637,
    y1: 988,
    x2: 654,
    y2: 988
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 469 487.8799)",
    writingMode: "tb"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 0
  }, "CENTER"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 1
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 64.239,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 0
  }, "HALF"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 630 482.8799)",
    writingMode: "tb"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 0
  }, "CENTER"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 1
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 64.239,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 0
  }, "THIRD"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1286 482.8799)",
    writingMode: "tb"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 0
  }, "CENTER"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 1
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 64.239,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 0
  }, "THIRD"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 642.8799 550)",
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1448 487.8799)",
    writingMode: "tb"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 0
  }, "CENTER"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 1
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 64.239,
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 10,
    glyphOrientationVertical: 0
  }, "HALF"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: -1,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 18.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 37.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 56.859,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 76.141,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 95.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 114.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 134,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 153.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 172.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 191.859,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 211.141,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 230.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 249.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 269,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 288.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 307.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 326.859,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 346.141,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 365.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 384.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 404,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 423.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 442.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 461.859,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 481.141,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 500.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 519.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 539,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 558.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 577.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 596.858,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 616.142,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 635.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 654.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 674,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 693.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 712.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 731.858,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 751.142,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 770.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 789.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 809,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 828.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 847.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 866.858,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 886.142,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 905.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 924.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 944,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 963.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 982.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 1001.858,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 1021.142,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 1040.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.761,
    y: 1059.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 216.4771 544)",
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 12
  }, "4:3")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: -1,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 18.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 37.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 56.859,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 76.141,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 95.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 114.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 134,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 153.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 172.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 191.859,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 211.141,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 230.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 249.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 269,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 288.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 307.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 326.859,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 346.141,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 365.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 384.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 404,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 423.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 442.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 461.859,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 481.141,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 500.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 519.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 539,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 558.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 577.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 596.858,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 616.142,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 635.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 654.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 674,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 693.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 712.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 731.858,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 751.142,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 770.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 789.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 809,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 828.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 847.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 866.858,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 886.142,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 905.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 924.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 944,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 963.285,
    fill: "#0985CF",
    width: 5.332,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 982.569,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 1001.858,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 1021.142,
    fill: "#0985CF",
    width: 5.332,
    height: 12.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 1040.431,
    fill: "#0985CF",
    width: 5.332,
    height: 12.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1677.761,
    y: 1059.713,
    fill: "#0985CF",
    width: 5.332,
    height: 12.947
  }))))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1686.6035 544)",
    opacity: 0.3,
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 12
  }, "4:3")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrackets);
export default __webpack_public_path__ + "static/media/Brackets.ca46e367ff71fa450ccbd5d787321743.svg";
export { ForwardRef as ReactComponent };